/* eslint-disable max-lines */

const iconSizes = ['xxs', 'xs', 's', 'm', 'l', 'xl', 'xxl'];

const iconColors = [
  ['neutral', '900'],
  ['neutral', '0'],
  ['danger', '900'],
  ['warning', '500'],
  ['success', '900'],
  ['brand-primary', '600'],
];

export { iconSizes as a, iconColors as i };
//# sourceMappingURL=prop-types-8c5debac.js.map
